import { jwtDecode, JwtPayload } from "jwt-decode";
import { ReceiveTicketForm } from "../types/booking";
import axiosInstance from "./axiosInstance";
import { fetchPOpup } from "../api/queries/popupQueries";

class BookingService {
  static async checkTicket(request: {
    bookNo: string;
    contact: string;
    contactType: string;
  }): Promise<any | undefined> {
    try {
      const response = await axiosInstance.post<ApiResponse<void>>(
        `/bookings/checkTicket`,
        request,
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async getTicket(request: {
    subject: string;
    email: string;
    infoTicket: string;
  }): Promise<any | undefined> {
    try {
      const response = await axiosInstance.post<ApiResponse<void>>(
        `/bookings/getTicket`,
        request,
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async saveBooking(
    request: BookingRequest,
    isUpdate?: boolean,
  ): Promise<any | undefined> {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token) as JwtPayload;
      if (decodedToken) {
        request.userId = Number(decodedToken.sub);
      }
    }

    try {
      const response = await axiosInstance.post<ApiResponse<void>>(
        isUpdate ? "/bookings/update" : "/bookings",
        request,
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async save(
    request: AllBookingRequestDTO,
    isUpdate?: boolean,
  ): Promise<any | undefined> {
    try {
      const response = await axiosInstance.post<ApiResponse<void>>(
        isUpdate ? "/bookings/update" : "/bookings",
        request,
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async getBooking(id: string): Promise<BookingResponseDTO> {
    try {
      const response = await axiosInstance.get<ApiResponse<BookingResponseDTO>>(
        `/bookings/${id}`,
      );

      console.log("response.data", response.data?.result);
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  // static async getBooking(id: number): Promise<BookingInfo> {
  //   try {
  //     const response = await axiosInstance.get<ApiResponse<BookingInfo>>(`/bookings/${id}`);
  // 		return response.data?.result;
  //   } catch (error) {
  // 		throw error;
  // 	};
  // }

  static async receiveTickeInfo(
    bookNo: string | number,
    bookingDetailId: number,
  ): Promise<any | undefined> {
    try {
      const response = await axiosInstance.post<ApiResponse<void>>(
        `/bookings/receive-ticket`,
        {
          bookNo: bookNo,
          bookingDetailId: bookingDetailId,
        },
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async selectTimeLater(
    request: BookingRequestDTO,
  ): Promise<any | undefined> {
    try {
      const response = await axiosInstance.post<ApiResponse<void>>(
        `/bookings/select-time-later`,
        request,
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async getReceiveInfo(
    bookingDetailId: string | number,
    productId: number,
  ): Promise<ReceiveTicketForm | undefined> {
    try {
      const response = await axiosInstance.get<ApiResponse<ReceiveTicketForm>>(
        `/booking/receive-ticket`,
        {
          params: {
            bookingDetailId,
            productId,
          },
        },
      );
      return response.data?.result;
    } catch (error) {}
  }

  // static async updateSelectDate(
  //   bookingId: string,
  //   productId: number,
  //   priorities: Priority[]
  // ): Promise<any | undefined> {
  //   try {
  //     const modifiedPriorities = priorities.map((priority) => {
  //       if (priority?.date && priority?.timeSlots?.value) {
  //         const date = dayjs(priority.date, "MM/DD/YYYY", true); // Parse with specific format
  //         const time = dayjs(priority.timeSlots.value, "HH:mm A", true);

  //         if (!date.isValid() || !time.isValid()) {
  //           return { date: priority.date, timeSlots: priority.timeSlots.id }; //Or you can return null or throw an error here if invalid
  //         }

  //         const dateTime = dayjs(
  //           `${date.format("YYYY-MM-DD")} ${time.format("HH:mm")}`
  //         ).valueOf();

  //         return {
  //           date: priority.date,
  //           timeSlots: priority.timeSlots.id,
  //           dateTime,
  //         };
  //       }

  //       return { date: priority.date, timeSlots: priority.timeSlots?.id };
  //     });

  //     const response = await axiosInstance.post<ApiResponse<any>>(
  //       `/booking/receive-ticket`,
  //       {
  //         bookingId,
  //         productId,
  //         priorities: modifiedPriorities,
  //       }
  //     );

  //     return response.data?.result;
  //   } catch (error) {
  //     console.error("Error updating select date:", error);
  //     return undefined; // Or handle the error differently
  //   }
  // }
  static async getMyBooking(
    pageIndex: number,
    pageSize: number,
    status: string,
  ): Promise<PageResult<BookingResponseDTO>> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<PageResult<BookingResponseDTO>>
      >(`/bookings`, {
        params: {
          pageIndex,
          pageSize,
          status,
        },
      });
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async getMyBookingByIds(
    pageIndex: number,
    pageSize: number,
    ids: string[],
  ): Promise<PageResult<BookingResponseDTO>> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<PageResult<BookingResponseDTO>>
      >(`/bookings/ids`, {
        params: {
          pageIndex,
          pageSize,
          ids: ids.join(","),
        },
      });
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async getVoucher(code: string): Promise<any[] | undefined> {
    try {
      const response = await axiosInstance.get<ApiResponse<any>>(`/cart`, {
        params: {
          code,
        },
      });
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async refundBooking(
    request: CancelBookingRequest,
  ): Promise<any[] | undefined> {
    const response = await axiosInstance.post<ApiResponse<any>>(
      `/bookings/cancel`,
      request,
    );
    return response.data?.result;
  }

  static async changeRequest(
    request: ChangeRequestDTO,
  ): Promise<any[] | undefined> {
    const response = await axiosInstance.post<ApiResponse<any>>(
      `/bookings/change-request`,
      request,
    );
    return response.data?.result;
  }

  static async refundContent(
    bookingId: string,
    title?: string,
    t?: (key: string) => string,
  ): Promise<any | undefined> {
    try {
      const data = await fetchPOpup({
        deliveryMethod: "GENERAL",
      });
      return {
        title,
        content: data?.contentConfirmCancel
          ? this.formatNewlineContent(
              t?.(data.contentConfirmCancel) ?? data.contentConfirmCancel,
            )
          : `Downgrading will limit some services, and refunds will be handled based on our cancellation and refund policy.
        <br/><br/>
        To proceed, please click the confirm button below.`,
        noteContent: "*Check the cancellation and refund policy",
      };
    } catch (error) {
      throw error;
    }
  }
  static async updrageContent(bookingId: string): Promise<any | undefined> {
    try {
      const data = await fetchPOpup({
        deliveryMethod: "GENERAL",
      });
      return {
        title: "Are you sure you want to downgrade?",
        content: data?.contentConfirmUpgrade
          ? this.formatNewlineContent(data.contentConfirmUpgrade)
          : `Downgrading will limit some services, and refunds will be handled based on our cancellation and refund policy.
				<br/>
				<br/>
				To proceed, please click the confirm button below.`,
        noteContent: "*Check the cancellation and refund policy",
      };
    } catch (error) {
      throw error;
    }
  }
  static async forgetTicket(request: {
    email: string;
  }): Promise<any | undefined> {
    try {
      const response = await axiosInstance.post<ApiResponse<void>>(
        `/bookings/ticket/forget`,
        request,
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }
  static formatNewlineContent = (content: string) => {
    if (!content) return "";
    // Replace newlines with <br /> and return
    return content
      .split("\n")
      .map((line) => line.trim())
      .join("<br />");
  };
}

export default BookingService;
